import React from 'react';
import classnames from 'classnames';
import renderIf from 'render-if';

const Facet = ({ active, onClick, name, count, showCount }) => {
  return (
    <li className={classnames({ facet: true, 'facet--active': active })}>
      <a onClick={onClick}>
        <div className='facet__name'>{name}</div>
        {renderIf(active)(
          <i className='facet__disable fa-regular fa-circle-xmark' />
        )}
        {renderIf(showCount)(<div className='facet__count'>{count}</div>)}
      </a>
    </li>
  );
};

export default Facet;
